module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('van-tabs', {
    staticClass: "tab-nav",
    attrs: {
      "sticky": ""
    },
    on: {
      "click": _vm.onStatusChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "全部"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "报名中"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "报名成功"
    }
  }), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(order, index) {
    return _c('div', {
      key: index,
      staticClass: "row-list",
      on: {
        "click": function($event) {
          return _vm.goDetail(order)
        }
      }
    }, [_c('div', {
      staticClass: "justify-space-flex row-title"
    }, [_c('div', {
      staticClass: "title-left flex-start gray"
    }, [_c('img', {
      staticClass: "row-title-img",
      attrs: {
        "src": "https://static.dierqudao.com/images/dinghuoxitong/icon-date.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(order.create_time_str))])]), _vm._v(" "), (order.memberstatus == 1) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                联系人信息\n                            ")]) : (order.memberstatus == 2) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                人员信息\n                            ")]) : (order.memberstatus == 3) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                等级申报\n                            ")]) : (order.memberstatus == 4) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                等待付款\n                            ")]) : (order.memberstatus == 6) ? _c('div', {
      staticClass: "title-right green"
    }, [_vm._v("\n                                报名成功\n                            ")]) : (order.memberstatus == 10) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                论文科报会申报\n                            ")]) : (order.memberstatus == 20) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                校局长论坛申报\n                            ")]) : (order.memberstatus == 30) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                七彩星级申报\n                            ")]) : (order.memberstatus == 41) ? _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v("\n                                导师申报\n                            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "justify-space-flex row-goods"
    }, [_c('div', {
      staticClass: "row-left flex-start"
    }, [_c('div', {
      staticClass: "goods-detail"
    }, [_c('div', {
      staticClass: "goods-name"
    }, [_vm._v(_vm._s(order.saiqu_name))]), _vm._v(" "), _c('div', {
      staticClass: "goods-weight gray-light"
    }, [_vm._v("\n                                        " + _vm._s(order.danwei) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
      staticClass: "row-right"
    }, [_c('div', {
      staticClass: "goods-price"
    }, [_c('span', [_vm._v("¥")]), _vm._v(_vm._s(order.total_price))]), _vm._v(" "), _c('div', {
      staticClass: "goods-num gray-light"
    }, [_vm._v("人数 " + _vm._s(order.membercount))])]), _vm._v(" "), (order.shenhe_status == 3) ? _c('van-notice-bar', {
      attrs: {
        "wrapable": "",
        "scrollable": false,
        "text": '资质审核不通过，理由：' + order.shenhe_reason + ''
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "row-btn"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (order.can_refund == 1),
        expression: " order.can_refund==1"
      }],
      staticClass: "look-order",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.refund(order)
        }
      }
    }, [_vm._v("申请退款")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (order.memberstatus == 6),
        expression: "order.memberstatus==6"
      }],
      staticClass: "look-order",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.beizhu(order)
        }
      }
    }, [_vm._v("支付凭证上传")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (order.saiqu == 906),
        expression: "order.saiqu==906"
      }],
      staticClass: "look-order",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.memberEdit(order)
        }
      }
    }, [_vm._v("修改人员信息")]), _vm._v(" "), (order.memberstatus == 6) ? _c('div', {
      staticClass: "look-order",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toZizhi($event)
        }
      }
    }, [_vm._v("我的资质")]) : _vm._e(), _vm._v(" "), (order.memberstatus == 6 && (order.saiqu == 443 || order.saiqu == 444 || order.saiqu == 446) && !order.jiesong_pay_time) ? _c('div', {
      staticClass: "look-order",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toJiesong(order)
        }
      }
    }, [_vm._v("接送站")]) : _vm._e(), _vm._v(" "), (order.memberstatus == 6 && (order.saiqu == 443 || order.saiqu == 444 || order.saiqu == 446) && order.jiesong_confirm_status == 1 && !_vm.isApp) ? _c('div', {
      staticClass: "look-order",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toJiesongConfirm(order)
        }
      }
    }, [_vm._v("接送信息确认")]) : _vm._e()])])
  }), 0)], 1)], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b820823","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiApplyList.vue
// module id = 2254
// module chunks = 0